/* global productTileData */
import Vue from 'vue';
import { toggleClass, toggleAttribute } from './helpers';

const productData = productTileData.products;

new Vue({
	el: '.family-landing-container',
	data: {
		products: productData,
		defaultAlts: productTileData.filteredTerms,
		filteredAlts: [],
		filteredTax: productTileData.filteredTax,
		filteredTaxLabel: productTileData.filteredTaxLabel,
		renderNow: 12,
		totalFilteredProducts: productData.length,
		isFiltered: false,
		gridLayout: true
	},
	computed: {
		filteredProducts() {
			if (this.isFiltered) {
				// return products that have dietary alts in this.defaultAlts[]
				return (this.products = productData.filter(product => {
					return product[this.filteredTax].some(alt => {
						return this.filteredAlts.includes(alt.name);
					});
				}));
			} else {
				return (this.products = productData);
			}
		}
	},
	methods: {
		handleInput() {
			this.hasFiltered();
			this.resetPage();
		},
		hasFiltered() {
			this.filteredAlts.length
				? (this.isFiltered = true)
				: (this.isFiltered = false);
		},
		handleToggle(e) {
			var changeEvent = new Event( 'change' );

			e.target.nextElementSibling.checked = !e.target.nextElementSibling.checked;
			e.target.nextElementSibling.dispatchEvent( changeEvent );
		},
		filterToggled(alt) {
			return this.filteredAlts.includes(alt);
		},
		resetFilters() {
			this.isFiltered = false;
			this.filteredAlts = [];
			this.products = productData;
			this.resetPage();
		},
		toggleLayout() {
			this.gridLayout = !this.gridLayout;
		},
		mobileFilterToggle( e ) {
			toggleClass(document.body, 'product-filters-open');
			toggleAttribute( e.target, 'aria-expanded' );
		},
		resetPage(e) {
			this.renderNow = 12;
		},
		loadMore(e) {
			let products =  this.$refs.productTile.length;
			this.renderNow += 12;
			e.target.blur();
			this.$nextTick( function() {
				this.$refs.productTile[products].focus();
				this.$refs.productTile[products].scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				});
			});
		},
	}
});
